import { Button, Checkbox, Col, Form, Input, Row } from 'antd';
import TextArea from 'antd/es/input/TextArea';
import React from 'react'
import ConfirmationBox from '../../../../../../components/common/ConfirmationBox';
import MultiSelect from '../../../../../../components/common/MultiSelect';
import { names } from '../../../../../../data/people';

function NotifyOwner({workOrderNumber, setIsConfirmationBoxOpen}) {
  return (
   
      <ConfirmationBox setIsConfirmationBoxOpen={setIsConfirmationBoxOpen}>
        <h2>Notify Owner for Work Order #{workOrderNumber}</h2>
        <Form layout='vertical'>
            <Row>
                <Col span={24}>
                    <Form.Item label="Recipients" required>
                        <MultiSelect options={names} placeholder="Select" />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label="Send BCC to">
                        <MultiSelect options={names} placeholder="Select" />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label="Email subject" required>
                        <Input placeholder="Subject here" />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item label="Email body">
                        <TextArea rows={10} />
                    </Form.Item>
                </Col>
                <Col span={24}>
                    <Form.Item>
                        <Checkbox>Attach the Work Order PDF</Checkbox>
                    </Form.Item>
                </Col>
            </Row>
            <div className="action-buttons">
                <Button type='primary'>Save</Button>
                <button className="cancel-btn" onClick={()=>setIsConfirmationBoxOpen(false)}>Cancel</button>
            </div>
        </Form>
      </ConfirmationBox>
    
  )
}

export default NotifyOwner;
